import { RemindersSection } from '@/components/reminders/RemindersSection';

export function AdminRemindersSection() {
  return (
    <div className="space-y-4">
      <div>
        <h1 className="text-2xl font-bold text-slate-900">Hatırlatıcılar</h1>
        <p className="mt-1 text-sm text-slate-500">Ödeme ve operasyon hatırlatıcıları</p>
      </div>
      <RemindersSection />
    </div>
  );
}
